import { defineAsyncComponent } from 'vue'
export default {
  dashboard: defineAsyncComponent(() => import("/www/wwwroot/FTS/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/www/wwwroot/FTS/layouts/default.vue").then(m => m.default || m))
}